import StickyHeader from '../components/StickyHeader'
import Footer from '../components/Footer'
import Cta from '../components/Cta'

import PillContainer from './components/PillContainer'
import HeroBanner from './components/HeroBanner'
import { FeaturedDeals } from './components/FeaturedDeals'
import LogoCloud from './components/LogoCloud'
import Blade from './components/Blade'


import useTitle from '../hooks/useTitle'

const HomepageApp = () => {
  useTitle('The Convoy | Save on everyday business expenses.');

  return (
    <div className="bg-convoy-homepage">
      <StickyHeader />

      <div className="mx-auto max-w-container">
        <FeaturedDeals />
      </div>

      <div className="container mt-6">
        <LogoCloud />
      </div>

      <div className="container mt-8 lg:mt-12 space-y-16">
        <Blade 
          title={<span>Small businesses save more, <span className="text-blue-800">together</span></span>}
          subtitle="Pool your buying power with thousands of other small businesses to access savings usually reserved for national chains." 
          image="/images/homepage/homepage_2@2x.png"
          alt="homepage-blade-image-quickbooks-web"
        />
  
        <Blade 
          title={<span><span className="text-blue-800">Savings</span> for every business type</span>}
          subtitle="No matter your industry or business size, The Convoy offers savings on the products and solutions you need to thrive & grow." 
          image="/images/homepage/homepage_3@2x.png"
          alt="homepage-blade-image-skillshare-squarespace-quickbooks-tiles"
          reversed
        />
  
        <Blade 
          title={<span>Small businesses <span className="text-blue-800">never pay</span> to join</span>}
          subtitle="We’re doing all we can to support small businesses, so your membership is completely free. (Yep. Seriously.)" 
          image="/images/homepage/homepage_4@2x.png"
          alt="homepage-blade-image-tiles"
        />
      </div>

      <div className="container xl:mx-28 mt-8">
        <hr />
      </div>
    

      <div className="container mt-12">
        <div className="xl:mx-28 md:mt-14 flex flex-col md:flex-row md:space-x-4 md:relative">
          <div className="mx-auto w-full text-center md:w-1/2 md:self-center md:text-left">
            <div className="xl:pr-2">
              <h2 className="font-secondary text-overline uppercase text-blue-700">Partnerships</h2>
              <h2 className="mt-4 font-secondary tracking-tight text-center md:text-left text-headline-2 md:text-headline-2-md 2xl:text-headline-2-lg">
                <span className="block xl:inline">Help other small businesses save</span>
              </h2>
              <p className="mt-4 mx-auto font-primary text-body-1 md:text-body-1-md 2xl:text-body-1-lg">Join our <span className="text-blue-800">Partner Program</span> to refer other small businesses and be the hero who helps them save, too.
              </p>
              <div className="mt-4 sm:flex sm:justify-center lg:justify-start">
                <a className="font-primary text-blue-500 text-link md:text-link-md 2xl:text-link-lg underline" href="">Learn More</a>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 mt-6 md:mt-0">
            <img
              className=""
              src="/images/homepage/homepage_6@2x.png"
              alt="footer-office-image"
            />
          </div>

          {/*
          <div className="hidden lg:relative">
            <div className="mx-auto w-full pb-8 lg:pb-20 lg:pt-28 lg:text-left text-center">
              <div className="space-y-4 lg:w-1/2 xl:pr-2">
                <h2 className="font-secondary text-overline lg:text-overline-lg uppercase text-blue-700">Partnerships</h2>
                <h1 className="font-secondary text-headline-2 md:text-headline-2 lg:text-headline-2-lg leading-[36px] text-gray-900">
                  <span className="block xl:inline">Help other small businesses save</span>
                </h1>
                <p className="mx-auto text-body-1 md:text-body-1-md lg:text-body-1-lg">
                  Join our <span className="text-blue-800">Partner Program</span> to refer other small businesses and be the hero who helps them save, too.
                </p>
                <div className="lg:mt-10 sm:flex sm:justify-center lg:justify-start">
                  <a href="">Learn More</a>
                </div>
              </div>
            </div>
            <div className="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
              <img
                className="absolute inset-0 w-full h-full object-contain"
                src="/images/homepage/homepage_6@2x.png"
                alt=""
              />
            </div>
          </div>
          */}

        </div>
      </div>

      <div className="container mt-12 lg:mt-20">
        <div className="flex flex-col text-white items-center bg-blue-700 rounded-[65px] px-[30px] py-10 lg:px-16">
          <div className="font-secondary text-headline-2 md:text-headline-2-md 2xl:text-headline-2-lg">Start saving today.</div>
          <p className="font-primary text-body-1 md:text-body-1-md 2xl:text-body-1-lg my-4 text-center">Becoming a member only takes a moment, and you can start redeeming savings offers immediately.</p>
          <Cta label="Access Member Savings" href="/register" style="style-4" />
        </div>
      </div>

      <div className="container mx-auto">
        <Footer />
      </div>
    </div>
  )
}

export { HomepageApp };
